"use client";
import ReactDOM from "react-dom";

export function PreloadResources({ host }: { host: string }) {
	ReactDOM.preconnect(`https://${host}`);
	// ReactDOM.preload('...', { as: '...' })
	// ReactDOM.prefetchDNS('...')

	return null;
}
